<template>
    <div>
      <h2>수업관리</h2>
      <p>
        Tens에듀는 수업이라는 개념을 통하여 학생들을 관리합니다. <br/>
        예를들어 A반이 생성되었고 A반의 수업이 매주 월요일에 열린다고 할 때, 수업은 그 반에서 이루어지는 수업을 말합니다.<br/>
        수업에는 수업내용 / 진도처리 / 숙제 / 시험 / 출결 등의 정보를 기록합니다. <br/>
        홈화면에서 나타나는 오늘 수업이라는 개념은 반에 의해서 이루어지는 수업 중 오늘 이루어지는 수업 리스트를 말합니다.<br/>
        이러한 <span class="bg-yellow-13">수업을 관리하고 조직화하는 방법</span>은 <span class="bg-light-green-13">타사의 학원관리프로그램과 차별화된 핵심적인 내용</span>입니다.<br/>
        Tens에듀는 수업이라는 개념을 도입하여, 강사가 수업하고 숙제와 시험을 기록하고 출결정보를 기록한 내용을 토대로 자동으로 수업후기 문구를 생성합니다.<br/>
        수업이 끝난 후에 하루를 마치며 부모님께 수업후기를 보내는 내용까지의 프로세스를 규격화함으로써 보다 쉬우면서도 가장 최적화된 학생관리를 가능하도록 합니다.<br/>
        따라서, 정말 학생관리를 잘하려면, 당연히 Tens에듀를 사용해야 합니다.<br/>
      </p>
      
      <section>
        <div class="p-relative section_0" id="class_manage">
            <div class="ft-b">1)    수업관리</div>
        
            <div class="p-relative section_1">
                -   수업관리 > 오늘수업을 클릭하여 수업관리 화면으로 이동합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/teacher/teacher_class_info.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="class_today">
            <div class="ft-b">2)    오늘 수업 리스트</div>
        
            <div class="p-relative section_1">
                -   수업관리의 수업리스트는 로그인한 선생님과 관련된 수업만 나타난다.
            </div>
            <div class="p-relative section_1">
                -   홈화면의 오늘수업은 학원 전체의 수업리스트가 나타난다.
            </div>

            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/teacher/teacher_class_today.jpg" /></div>
            </div>

            <div class="p-relative section_1">
                -   날짜를 변경시<br/>
                    1주일후까지는 나타나지만, 그 이후의 미래 수업은 나타나지 않습니다. <br/>
                    이는 수업은 최대 1주일분까지만 미리 생성되기 때문입니다.<br/>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="class_student">
            <div class="ft-b">3)    수업 학생 리스트</div>
        
            <div class="p-relative section_1">
                -   수업이 선택되면 학생리스트에 학생이 나타납니다.
            </div>
            
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/teacher/teacher_class_board.jpg" /></div>
            </div>

            <div class="p-relative section_1">
                -   수업 학생 리스트에서 출결을 설정하고 결석학생에 대하여 보강을 잡을 수 있습니다
            </div>
            <div class="p-relative section_1">
                -   지난과제에 대하여 평가를 하고, 만약 학생이 과제를 안가져 온 경우 “기한연장”을 통하여 다시 검사할 과제 날짜를 연장할 수 있습니다.
            </div>
            <div class="p-relative section_2">
                “기한연장”은 개별적으로 학생에 대한 설정이 가능합니다.
            </div>
            <div class="p-relative section_1">
                -   수업시간에 시험을 보는 경우, 이 결과를 채점하여 점수를 기록합니다.
            </div>
        </div>


        <p></p>
        <div class="p-relative section_0" id="class_after">
            <div class="ft-b">4)    수업후기</div>
        
            <div class="p-relative section_2">
                <span class="bg-yellow-13">성장하는 학원이 되기 위하여</span> 오늘 수업한 내용을 <span class="bg-light-green-13">부모님께 보내는 수업후기</span>가 필수입니다. 이는 부모님과의 소통의 첫걸음이고 학원의 만족도를 극대화하는 방법이죠.
            </div>
            
            <div class="p-relative section_2">
                수업 학생리스트에서 학생에 대한 정보를 입력하였다면 이를 바탕으로 부모님께 오늘의 수업에 대한 수업후기 내용을 문자로 보낼 수 있습니다.
            </div>
            
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/teacher/teacher_class_after.jpg" /></div>
            </div>

            <div class="p-relative section_1">
                -   “진도”탭에서 오늘 수업의 제목과 내용을 입력합니다. 
            </div>
            <div class="p-relative section_1">
                -   “수업후기”탭을 클릭하여
            </div>

            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/teacher/teacher_class_after_send.jpg" /></div>
            </div>


            <div class="p-relative section_1">
                -   “기본메시지”를 클릭하면 수업후기에 보내지는 문구가 나타납니다.
            </div>
            <div class="p-relative section_2">
                문구는 수정하여 “제목+내용저장”버튼을 통하여 저장해 둘 수 있습니다.
            </div>
            <div class="p-relative section_2">
                학생을 선택하고 “미리보기”버튼을 클릭하면 발송될 메시지의 내용을 볼 수 있습니다.
            </div>
            <div class="p-relative section_1">
                -   #{학생이름}은 여러 명의 학생을 보낼 때 자동으로 치환되는 기능입니다.
            </div>
            <div class="p-relative section_1">
                -   학생을 선택하고 “수업후기”문자를 발송합니다.
            </div>

        </div>
        

        
      </section>

      <q-drawer show-if-above side="right" class="bg-white">
          <q-list>
            <q-item-label header style="padding:40px 42px 20px;">바로가기</q-item-label>
            <li class="q-px-lg pointer" 
                      v-for="m in menuItems" 
                      :key="m.label"
                      @click="goTo(m.link)" >
                {{m.label}}
            </li>
            
          </q-list>
      </q-drawer>
    </div>
</template>

<script>
import goto from "./goto.js";
export default {
    components : {
    },
    data : function() {
        return {
            menuItems: [
                { label: '수업관리', link: '#class_manage' },
                { label: '오늘 수업 리스트', link: '#class_today' },
                { label: '수업 학생 리스트', link: '#class_student' },
                { label: '수업후기', link: '#class_after' },
            ]
        }
    },
    computed :{
    },
    methods : {
        goTo(link) {
            goto.goto_link(link);
        }
    },
    beforeMount() {
        goto.clear();
    }
}
</script>


